import useBridgeClient from "src/common/hooks/BridgeSWRClient";
import { endpoint } from "src/lib/bridgeClient";

export const useGetBlueprintSchedulers = (blueprintId: number) => {
  const { data, error } = useBridgeClient<Scheduler[]>(endpoint.stackSchedulers(blueprintId));

  return { data, error };
};

export const useGetMySchedulers = () => {
  const { data, error } = useBridgeClient<Scheduler[]>(endpoint.mySchedulers);

  return { data, error };
};
